import { Typography } from 'antd';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { WidgetLoader } from 'datastake-daf/dist/components';
import Tooltip from './BasicTooltip';
import Chart from '../../../../../../screens/Modules/pme/screens/dashboard/widgets/sdgs/chart';

const { Paragraph } = Typography;

const _config = {
  completed: {
    color: '#16B364',
    label: 'Completed',
  },
  inProgress: {
    color: '#2E90FA',
    label: 'In Progress',
  },
  proposed: {
    color: '#8F66F8',
    label: 'Proposed',
  },
}

const CorrectiveActionPlan = ({ data = {}, loading = true }) => {
  const { t } = useTranslation();

  // const _total = useMemo(() => Object.values(data?.score || {}).reduce((all, val) => all + val, 0), [data]);

  const items = useMemo(() => {
    if (data && data.percentage) {
      return Object.keys(_config).map((k) => ({
        ..._config[k],
        percent: (data.percentage[k] || 0),
        score: data[k],
      }))
    }

    return [];
  }, [data]);

  const isEmpty = useMemo(() => !items.filter((it) => it.percent).length, [items]);

  const _renderTooltip = ({ mouseX, mouseY, item }) => {
    const label = t(item?.label);
    const value = `${item.score}/${data.total}`;

    return (
      <Tooltip
        mouseY={mouseY}
        mouseX={mouseX}
        label={label}
        value={value}
        color={item?.color}
        type="RISK"
        isEmpty={isEmpty}
        t={t}
      />
    )
  }

  return (
    <div className="cont">
      <div className="h4-cont">
        <Paragraph className="h4" ellipsis={{ rows: 2, tooltip: t('Corrective Action Plan') }}>
        {t('Corrective Action Plan')}
        </Paragraph>
      </div>
      <div className="chart-cont">
        {loading && <WidgetLoader background="white" />}
        <Chart
          data={items}
          t={t}
          withBody={false}
          isEmpty={isEmpty}
          className="small-chart"
          renderTooltip={_renderTooltip}
        >
        </Chart>
      </div>
      <div className="p-cont">
        <p>
          {t('Risk mitigation recommendations consolidated from all stakeholders')}
        </p>
      </div>
    </div>
  );
};

export default CorrectiveActionPlan;
